import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconBridge"><Path d="M12 4.5C16.1421 4.5 19.5 7.85786 19.5 12V13.541C20.9189 13.779 22 15.0135 22 16.5C22 18.1569 20.6569 19.5 19 19.5C17.3431 19.5 16 18.1569 16 16.5C16 15.0135 17.0811 13.779 18.5 13.541V12C18.5 8.41015 15.5899 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12V13.541C6.91889 13.779 8 15.0135 8 16.5C8 18.1569 6.65685 19.5 5 19.5C3.34315 19.5 2 18.1569 2 16.5C2 15.0135 3.08111 13.779 4.5 13.541V12C4.5 7.85786 7.85786 4.5 12 4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBridge;
